var _this = this;
import isEqual from 'lodash/isEqual';
export default (function (fn) {
  var prevArgs = null;
  var cachedValue;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (isEqual(args, prevArgs)) {
      return cachedValue;
    }
    prevArgs = args;
    cachedValue = fn.apply(_this, args);
    return cachedValue;
  };
});